import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import AboutUs from '@/components/aboutUs'
import ESG from '@/components/ESG'
import Product from '@/components/product'
import ProductDetails from '@/components/productDetails'
import Store from '@/components/store'
import News from '@/components/news'
import NewsDetails from '@/components/newsDetails'
import ContactUs from '@/components/contactUs'
import SetAim from '@/components/setAim'
import SetAimDetails from '@/components/setAimDetails'
import Investor from '@/components/investor'
import InvestorDetails from '@/components/investorDetails'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      //path: '/8WayWeb',
      path: '/',
      name: 'Home',
      component: Home
    },
    {
     path: '/home',
     name: 'Home',
     component: Home
    },
    {
      path: '/aboutUs/:id',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/ESG',
      name: 'ESG',
      component: ESG
    },
    {
      path: '/ESG/0904',
      name: 'SetAim',
      component: SetAim
    },

    {
      path: '/ESG/:ids',
      name: 'ESG',
      component: ESG
    },

    {
      path: '/Product/:id',
      name: 'Product',
      component: Product
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/ProductDetails/:id',
      name: 'ProductDetails',
      component: ProductDetails
    },
    {
      path: '/investor/:ids',
      name: 'Investor',
      component: Investor
    },
    {
      path: '/investor',
      name: 'Investor',
      component: Investor
    },
    {
      path: '/investorDetails/:id',
      name: 'InvestorDetails',
      component: InvestorDetails
    },
    {
      path: '/store',
      name: 'Store',
      component: Store
    },
    {
      path: '/news/:id',
      name: 'News',
      component: News
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/newsDetails/:id',
      name: 'NewsDetails',
      component: NewsDetails
    },
    {
      path: '/contactUs/:id',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/contactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/setAim',
      name: 'SetAim',
      component: SetAim
    },
    {
      path: '/setAimDetails/:id',
      name: 'SetAimDetails',
      component: SetAimDetails
    },

  ],
  scrollBehavior (to, from, savedPosition) {
    return {y:0}
  }

})



// WEBPACK FOOTER //
// ./src/router/index.js